import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  ICardTransferTemplate,
  ICreateCardTransferTemplateRequest,
  IUpdateCardTransferTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const cardTransferTemplateApi = createApi({
  reducerPath: "cardTransferTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getCardTransferTemplate: builder.query<ICardTransferTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.CardTransferTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createCardTransferTemplate: builder.mutation<string, ICreateCardTransferTemplateRequest>(
      withIdempotency<ICreateCardTransferTemplateRequest>(
        TemplateApiUrls.CardTransferTemplateV2
      )),
    updateCardTransferTemplate: builder.mutation<string, IUpdateCardTransferTemplateRequest>({
      query: ({ data, id }) => ({
        url: `${TemplateApiUrls.CardTransferTemplateV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
  }),
});

export const {
  useGetCardTransferTemplateQuery,
  useCreateCardTransferTemplateMutation,
  useUpdateCardTransferTemplateMutation,
} = cardTransferTemplateApi;
